import { Subject } from "rxjs";
import { Injectable } from "@angular/core";
import {ErrorDialogComponent} from './error-dialog/error-dialog.component';
import {BsModalService} from 'ngx-bootstrap';
import {TranslateModule, TranslateService} from "@ngx-translate/core";
import {TagVerificationDialogComponent} from "./tag-verification-dialog/tag-verification-dialog.component";
import {ChangePasswordDialogComponent} from "./change-password/change-password-dialog.component";
import {histTagUpdate, modalConfig, modalConfigIgnorBack} from "../common/constant";
import {IntTag} from "../common/anti-theft-table";
import {environment} from "../../environments/environment";
import {HttpClient} from "@angular/common/http";
import {AuthService} from "../auth/auth.service";
// import {AuthService} from "../auth/auth.service";


@Injectable()
export class DialogsService {
  private errorListener = new Subject<string>();

  constructor(private modalService: BsModalService, private translate :TranslateService, private http: HttpClient ) {

  }

  showMsgDlg(title?: string, message?: string) {
    const self = this;
    function show(){
        const initialState = {data :{ message: message, title: title, btCancel: false, dError: true}};
        let bsModalRef = self.modalService.show(ErrorDialogComponent, Object.assign({}, modalConfig, { class: 'modal-md', initialState }));
        // console.log("bsModalRef: ", bsModalRef);
        bsModalRef.content.action.subscribe((value) => {
            // console.log('modal result:', value);
        });
    }
    if (!title){
        self.translate.get('E_1').subscribe((res: string) => {
           title = res;
           show();
            // console.log(res);
            //=> 'hello world'
        });

    } else {
      show();
    }

  }

  // getErrorListener() {
  //   return this.errorListener.asObservable();
  // }

  throwError(message: string) {
    this.showMsgDlg('', message);
    // this.errorListener.next(message);
  }

  // throwErrorDialog(message: string) {
  //   console.log('throwErrorDialog', message)
  //   this.showConfirm("Error", message);
  //   // this.dialog.open(ErrorDialogComponent, {data: {message: message}});
  // }



  handleError() {
    this.errorListener.next(null);
  }


    showVerifyDlg(data) {
        const self = this;
        function show(){
            const initialState = {data: data.extra};
            // console.log('showVerifyDlg', data, initialState);
            let bsModalRef = self.modalService.show(TagVerificationDialogComponent, Object.assign({}, modalConfigIgnorBack, { class: 'modal-md', initialState }));
            // console.log("bsModalRef: ", bsModalRef);
            // bsModalRef.content.action.subscribe((value) => {
            //     console.log('modal result:', value);
            // });
        }
        show();
    }


}
